let getters = {
  totalPaymentsAvailable (state) {
    return state.totalPaymentsAvailable
  },
  totalPaymentsFetched (state) {
    return state.unsettledTransactionList
  },
  payments (state) {
    return state.payments
  }

}
export default getters



// WEBPACK FOOTER //
// ./src/store/payments/getters.js